export default __webpack_public_path__ + "static/media/baylis_heart.53abc6c0.jpg";